import { IMAGES } from "@/data/site";
import { Reveal } from "@/components/Reveal";

const About = () => (
  <section id="about" className="border-y border-white/10 bg-surface" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-2 lg:gap-16">
      <div>
        <Reveal>
          <p className="eyebrow flex items-center gap-3">
            <span className="text-slate-500">04</span>
            <span className="h-px w-8 bg-blue-500/60" aria-hidden="true" />
            About
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Local. Convenient.
            <br />
            <span className="text-blue-500">Straightforward.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <div className="mt-7 max-w-lg space-y-5 text-base leading-relaxed text-slate-300 sm:text-lg">
            <p>
              Freedom Mobile Auto Detailing provides convenient mobile interior and exterior detailing for drivers
              throughout Gap and surrounding communities. Instead of spending your day driving to a detail shop and
              waiting around, we bring the equipment to you.
            </p>
            <p>
              Our goal is simple: provide thorough, reliable vehicle cleaning at straightforward prices while making
              the process as convenient as possible.
            </p>
            <p className="text-slate-400">
              Looking for mobile car detailing near Gap, PA? We serve everyday drivers, families, and working trucks
              across Lancaster and Chester County.
            </p>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1} y={40} className="relative">
        <div className="relative h-full min-h-[320px] overflow-hidden border border-white/10">
          <img
            src={IMAGES.dashboard}
            alt="Clean, freshly detailed vehicle interior dashboard"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian/60 to-transparent" aria-hidden="true" />
          <p className="absolute bottom-5 left-5 font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-300">
            Owner-operated — Gap, PA
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
